import db from 'src/lib/dexie-db/db';
import { NodeType } from 'src/modules/exam-preparation/graphql/common/types/node';
import SubjectAPIs from './subject';
import { getSafeData } from './utils';
const QPAPIs = {
    async getList(userID, subjectID, pagination = { offset: 0 }) {
        const { offset = 0, limit = 20 } = pagination;
        const qpType = await QPAPIs.getQPTypeFromSubject(userID, subjectID);
        let query = db.qnaNode
            .where('ancestors')
            .equals(subjectID)
            .and(node => node.type === qpType && !node.deleted);
        if (pagination) {
            query = query
                .offset(offset)
                .limit(limit);
        }
        const qps = await query.reverse().sortBy('utime');
        const totalCount = await db.qnaNode
            .where('ancestors')
            .equals(subjectID)
            .and(node => node.type === qpType && !node.deleted)
            .count();
        return {
            list: qps.map(getSafeData),
            totalCount,
        };
    },
    async getByID(userID, qpID) {
        const qp = await db.qnaNode.get(qpID);
        if (!qp ||
            ![NodeType.WRITTEN_QP, NodeType.ORALS_QP].includes(qp.type) ||
            qp.deleted) {
            throw new Error('Question paper not found');
        }
        return getSafeData(qp);
    },
    async getQPTypeFromSubject(userID, subjectID) {
        const subject = await SubjectAPIs.getByID(userID, subjectID);
        return subject.type === NodeType.WRITTEN_SUBJECT
            ? NodeType.WRITTEN_QP
            : NodeType.ORALS_QP;
    },
    async getForQuestion(userID, questionID) {
        const question = await db.qnaNode.get(questionID);
        if (!question) {
            throw new Error('Question not found');
        }
        // Get all ancestors to find the QP
        const ancestors = await db.qnaNode
            .where('_id')
            .anyOf(question.ancestors)
            .toArray();
        // Find the QP ancestor
        const qpAncestor = ancestors.find(ancestor => [NodeType.WRITTEN_QP, NodeType.ORALS_QP].includes(ancestor.type) && !ancestor.deleted);
        if (!qpAncestor) {
            throw new Error('Question paper not found for question');
        }
        return getSafeData(qpAncestor);
    },
    getSafeData,
};
export default QPAPIs;
